// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageUploader__content-cb537f {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: flex-start;
}

.ImageUploader__description-a4346f {
  margin-top: 8px;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}

.ImageUploader__upload-b36e25 {
  position: relative;
}

.ImageUploader__file-input-cb18ef {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
  font-size: 0;
  text-indent: -60px;
}

.ImageUploader__remove-avatar-f54f20 {
  margin-inline-start: 8px;
}

.ImageUploader__remove-avatar-f54f20:hover {
  background-color: var(--brand-primary-0);
}

.ImageUploader__error-f2eef2 {
  margin-top: 8px;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--danger-40);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/CreateStreamPopup/StreamForm/ImageUploader/ImageUploader.style.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,eAAA;EACA,4BAAA;EACA,8CAAA;EACA,uBAAA;AACF","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  align-self: flex-start;\n}\n\n.description {\n  margin-top: 8px;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n\n.upload {\n  position: relative;\n}\n\n.file-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  z-index: 1;\n  cursor: pointer;\n  font-size: 0;\n  text-indent: -60px;\n}\n\n.remove-avatar {\n  margin-inline-start: 8px;\n}\n\n.remove-avatar:hover {\n  background-color: var(--brand-primary-0);\n}\n\n.error {\n  margin-top: 8px;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--danger-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `ImageUploader__content-cb537f`,
	"description": `ImageUploader__description-a4346f`,
	"upload": `ImageUploader__upload-b36e25`,
	"file-input": `ImageUploader__file-input-cb18ef`,
	"fileInput": `ImageUploader__file-input-cb18ef`,
	"remove-avatar": `ImageUploader__remove-avatar-f54f20`,
	"removeAvatar": `ImageUploader__remove-avatar-f54f20`,
	"error": `ImageUploader__error-f2eef2`
};
module.exports = ___CSS_LOADER_EXPORT___;
